export const companies = [
  {
    id: "unizar",
    name: "Unizar",
    tagline: "AI-Native Digital Agency",
    website: "unizar.ai",
    category: "AI Solutions",
    industries: ["ai"],
    logo: "https://customer-assets.emergentagent.com/job_holding-hub/artifacts/tcujsgfg_Risorsa%204u.png",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=85&w=1200",
    description: "Unizar is a full-service digital agency that helps businesses transform their operations through AI-powered solutions. They specialize in building custom, AI-native technology — including autonomous agent systems, intelligent CRM platforms, and bespoke web and mobile applications — designed around each client's specific workflows rather than off-the-shelf software.",
    philosophy: "Their core philosophy is that AI should be the foundation of a system, not an afterthought bolted onto legacy tools. They primarily serve small to medium-sized businesses looking to improve efficiency, reduce operational costs, and modernize how they work.",
    services: [
      "Autonomous Agent Systems",
      "Intelligent CRM Platforms",
      "Custom Web Applications",
      "Mobile App Development",
      "AI Integration Services"
    ],
    stats: {
      founded: "2022",
      focus: "SMB Digital Transformation",
      specialty: "AI-Native Technology"
    }
  },
  {
    id: "precepta",
    name: "Precepta",
    tagline: "Clinical Placement Management",
    website: "precepta.co",
    category: "Healthcare Education",
    industries: ["healthcare", "education"],
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=85&w=1200",
    description: "Precepta is a clinical placement management platform designed for healthcare education. It connects universities and their students with clinical sites — hospitals, clinics, and healthcare organizations — to coordinate and manage real-world training placements.",
    philosophy: "At its core, Precepta streamlines the process of matching health sciences students (such as physical therapy, occupational therapy, and related fields) with clinical rotation opportunities. The platform handles the full placement lifecycle: from requests and approvals, to scheduling and notifications.",
    services: [
      "Student-Site Matching",
      "Placement Lifecycle Management",
      "Schedule Coordination",
      "Approval Workflows",
      "Real-time Notifications"
    ],
    stats: {
      founded: "2021",
      focus: "Healthcare Education",
      specialty: "Clinical Placements"
    }
  },
  {
    id: "loadexpress",
    name: "LoadExpress",
    tagline: "AI-Powered Freight Broker",
    website: "loadexpress.ai",
    category: "Logistics & Freight",
    industries: ["logistics"],
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=85&w=1200",
    description: "LoadExpress.ai is an AI-powered freight broker agent platform that automates the entire shipment lifecycle — from booking to delivery — without bid waiting, manual carrier vetting, or complicated forms. Shippers simply describe their load in plain language, and the AI agent sources pre-verified carriers, negotiates the best rate using live market data, and monitors the shipment in real time.",
    philosophy: "Built to compete directly against uShip, LoadExpress.ai replaces the passive bidding marketplace with an intelligent agent that works on the shipper's behalf, gets smarter with every shipment, and delivers a faster, more personalized freight experience that a generic marketplace can never replicate.",
    services: [
      "AI Load Booking",
      "Carrier Verification",
      "Real-time Rate Negotiation",
      "Shipment Monitoring",
      "Proactive Alerts"
    ],
    stats: {
      founded: "2023",
      focus: "Freight Automation",
      specialty: "AI Agent Platform"
    }
  },
  {
    id: "frqncy",
    name: "FRQNCY",
    tagline: "Music, AI & Digital Innovation",
    website: "frqncy.ai",
    category: "Creative Technology",
    industries: ["creative", "entertainment"],
    image: "https://images.unsplash.com/photo-1614149162883-504ce4d13909?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=85&w=1200",
    description: "FRQNCY blends music, AI, culture, and digital innovation into a unified platform. It is designed to empower creators, artists, and entrepreneurs to elevate their voice, amplify their signal, and build communities around their unique vibration.",
    philosophy: "The brand embraces technology as a creative amplifier — using AI, automation, and digital platforms to help individuals scale their ideas and presence without losing authenticity.",
    services: [
      "AI-Powered Music Tools",
      "Creator Community Platform",
      "Digital Brand Building",
      "Content Automation",
      "Artist Development"
    ],
    stats: {
      founded: "2023",
      focus: "Creative Empowerment",
      specialty: "Music & AI Fusion"
    }
  },
  {
    id: "kasa",
    name: "Kasa.la",
    tagline: "AI-Powered Real Estate Automation",
    website: "kasa.la",
    category: "Real Estate Technology",
    industries: ["realestate", "blockchain"],
    image: "",
    description: "KASA.LA is an AI-powered real estate automation platform designed to simplify and modernize the entire home buying and selling journey. Through its intelligent assistant, Kayla, KASA.LA guides users step-by-step—from listing a property and managing showings to generating purchase agreements, completing the 1003 loan application, and coordinating escrow, title, appraisal, and inspections—creating a seamless, fully managed digital experience.",
    philosophy: "Built as a proof of concept for the broader Living Automation vision, KASA.LA centralizes fragmented real estate processes into one intelligent system, reducing friction, increasing transparency, and delivering a faster, smarter way to transact.",
    services: [
      "AI Property Listings",
      "Intelligent Showing Management",
      "Purchase Agreement Generation",
      "Loan Application Automation",
      "Escrow & Title Coordination"
    ],
    stats: {
      founded: "2024",
      focus: "Real Estate Automation",
      specialty: "Living Automation"
    }
  },
  {
    id: "arqplus",
    name: "Arq+",
    tagline: "AI Design & Build Platform",
    website: "arqplus.co",
    category: "Construction Technology",
    industries: ["realestate"],
    logo: "https://customer-assets.emergentagent.com/job_holding-hub/artifacts/0wfk4qmk_TRANSPARENT-WHITE.png",
    image: "",
    description: "Arq+ uses AI to turn rough ideas into photorealistic designs, detailed specifications, and trackable build plans — all in one platform.",
    philosophy: "By combining generative AI with construction intelligence, Arq+ enables architects, builders, and homeowners to move from concept to construction faster and with greater precision than ever before.",
    services: [
      "AI Design Generation",
      "Photorealistic Rendering",
      "Detailed Specifications",
      "Build Plan Tracking",
      "Project Management"
    ],
    stats: {
      founded: "2024",
      focus: "Construction Tech",
      specialty: "AI-Powered Design"
    }
  },
  {
    id: "shipxchange",
    name: "shipXchange",
    tagline: "AI Freight Exchange",
    website: "shipxchange.com",
    category: "Logistics & Freight",
    industries: ["logistics", "blockchain"],
    image: "",
    description: "shipXchange is an AI-powered freight exchange platform that connects shippers and carriers through intelligent matching and real-time market dynamics. The platform leverages advanced algorithms to optimize load matching, pricing, and route efficiency across the logistics network.",
    philosophy: "By combining AI-driven automation with a transparent marketplace model, shipXchange creates a more efficient and fair freight ecosystem where both shippers and carriers can find the best opportunities and maximize their operational value.",
    services: [
      "AI Load Matching",
      "Real-time Freight Exchange",
      "Dynamic Pricing Engine",
      "Carrier Network Management",
      "Route Optimization"
    ],
    stats: {
      founded: "2024",
      focus: "Freight Marketplace",
      specialty: "AI Exchange Platform"
    }
  },
  {
    id: "cravyn",
    name: "Cravyn",
    tagline: "AI-Verified Food Intelligence",
    website: "cravyn.co",
    category: "Hospitality Technology",
    industries: ["hospitality"],
    image: "",
    description: "Cravyn is an AI-powered food intelligence platform that verifies and analyzes food quality, authenticity, and sourcing across the hospitality industry. The platform uses advanced AI to provide verified insights for restaurants, hotels, and food service providers.",
    philosophy: "By leveraging AI-verified intelligence, Cravyn helps hospitality businesses make informed decisions about their food offerings, ensuring quality, authenticity, and customer satisfaction.",
    services: [
      "AI Food Verification",
      "Quality Analysis",
      "Sourcing Intelligence",
      "Menu Optimization",
      "Customer Insights"
    ],
    stats: {
      founded: "2024",
      focus: "Food Intelligence",
      specialty: "AI Verification"
    }
  }
];

export const getCompanyById = (id) => {
  return companies.find(company => company.id === id);
};
